/* eslint-disable react/jsx-props-no-spreading */
import { COLOR } from 'admin/constants/styles';
import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';

type InputErrorsProp = {
  errors?: string[];
  fullWidth?: boolean;
};

export const ErrorDiv = styled.div`
  color: ${COLOR.errorMessage};
`;
export const ErrorsWrapper = styled.div``;

export const Container = styled.div<{ fullWidth: boolean }>`
  ${({ fullWidth }) => (fullWidth ? 'width: 100%;' : 'display: inline-block;')}
  ${ErrorsWrapper} {
    margin-top: 5px;
  }
`;

export const InputErrors = ({
  errors,
  fullWidth = false,
  children,
}: PropsWithChildren<InputErrorsProp>): JSX.Element => {
  const errorDivs =
    errors &&
    errors.map((message) => (message ? <ErrorDiv key={message}>{message}</ErrorDiv> : null));

  return (
    <Container fullWidth={fullWidth}>
      {children}
      {errors && errors.length > 0 ? <ErrorsWrapper>{errorDivs}</ErrorsWrapper> : null}
    </Container>
  );
};
